@file:OptIn(InternalResourceApi::class)

package acessoescola.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/acessoescola.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_708_460_330)
internal val Res.string.Authorized_data: StringResource by lazy {
      StringResource("string:Authorized_data", "Authorized_data", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 59),
      ))
    }

@delegate:ResourceContentHash(1_469_936_197)
internal val Res.string.add: StringResource by lazy {
      StringResource("string:add", "add", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 113, 23),
      ))
    }

@delegate:ResourceContentHash(397_478_371)
internal val Res.string.add_facial: StringResource by lazy {
      StringResource("string:add_facial", "add_facial", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 70, 42),
      ))
    }

@delegate:ResourceContentHash(949_329_099)
internal val Res.string.admin_panel_mobile: StringResource by lazy {
      StringResource("string:admin_panel_mobile", "admin_panel_mobile", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 137, 122),
      ))
    }

@delegate:ResourceContentHash(-1_683_236_217)
internal val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 260, 48),
      ))
    }

@delegate:ResourceContentHash(-747_396_985)
internal val Res.string.back: StringResource by lazy {
      StringResource("string:back", "back", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 309, 20),
      ))
    }

@delegate:ResourceContentHash(-1_866_581_848)
internal val Res.string.bound: StringResource by lazy {
      StringResource("string:bound", "bound", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 330, 49),
      ))
    }

@delegate:ResourceContentHash(515_583_929)
internal val Res.string.cancel: StringResource by lazy {
      StringResource("string:cancel", "cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 380, 26),
      ))
    }

@delegate:ResourceContentHash(-298_241_965)
internal val Res.string.connecting_to_server: StringResource by lazy {
      StringResource("string:connecting_to_server", "connecting_to_server", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 407, 120),
      ))
    }

@delegate:ResourceContentHash(2_462_277)
internal val Res.string.cpf: StringResource by lazy {
      StringResource("string:cpf", "cpf", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 528, 15),
      ))
    }

@delegate:ResourceContentHash(-94_188_950)
internal val Res.string.database_error: StringResource by lazy {
      StringResource("string:database_error", "database_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 544, 30),
      ))
    }

@delegate:ResourceContentHash(-1_277_032_214)
internal val Res.string.delete: StringResource by lazy {
      StringResource("string:delete", "delete", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 575, 26),
      ))
    }

@delegate:ResourceContentHash(-760_957_319)
internal val Res.string.edit: StringResource by lazy {
      StringResource("string:edit", "edit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 602, 20),
      ))
    }

@delegate:ResourceContentHash(-94_188_950)
internal val Res.string.error: StringResource by lazy {
      StringResource("string:error", "error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 623, 21),
      ))
    }

@delegate:ResourceContentHash(-625_771_994)
internal val Res.string.example: StringResource by lazy {
      StringResource("string:example", "example", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 645, 27),
      ))
    }

@delegate:ResourceContentHash(1_351_059_371)
internal val Res.string.exit: StringResource by lazy {
      StringResource("string:exit", "exit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 673, 20),
      ))
    }

@delegate:ResourceContentHash(1_235_089_538)
internal val Res.string.facial: StringResource by lazy {
      StringResource("string:facial", "facial", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 694, 22),
      ))
    }

@delegate:ResourceContentHash(186_621_119)
internal val Res.string.full_name: StringResource by lazy {
      StringResource("string:full_name", "full_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 717, 37),
      ))
    }

@delegate:ResourceContentHash(1_688_077_807)
internal val Res.string.hint_screen_header: StringResource by lazy {
      StringResource("string:hint_screen_header", "hint_screen_header", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 755, 50),
      ))
    }

@delegate:ResourceContentHash(1_253_055_917)
internal val Res.string.hint_screen_line_1: StringResource by lazy {
      StringResource("string:hint_screen_line_1", "hint_screen_line_1", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 806, 158),
      ))
    }

@delegate:ResourceContentHash(685_580_061)
internal val Res.string.hint_screen_line_2: StringResource by lazy {
      StringResource("string:hint_screen_line_2", "hint_screen_line_2", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 965, 174),
      ))
    }

@delegate:ResourceContentHash(-440_591_748)
internal val Res.string.hint_screen_line_3: StringResource by lazy {
      StringResource("string:hint_screen_line_3", "hint_screen_line_3", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1140, 110),
      ))
    }

@delegate:ResourceContentHash(1_736_131_241)
internal val Res.string.hint_screen_line_4: StringResource by lazy {
      StringResource("string:hint_screen_line_4", "hint_screen_line_4", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1251, 162),
      ))
    }

@delegate:ResourceContentHash(-625_767_561)
internal val Res.string.hint_screen_line_5: StringResource by lazy {
      StringResource("string:hint_screen_line_5", "hint_screen_line_5", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1414, 38),
      ))
    }

@delegate:ResourceContentHash(2_101_505_339)
internal val Res.string.login: StringResource by lazy {
      StringResource("string:login", "login", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1453, 45),
      ))
    }

@delegate:ResourceContentHash(-856_305_904)
internal val Res.string.loyola: StringResource by lazy {
      StringResource("string:loyola", "loyola", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1499, 34),
      ))
    }

@delegate:ResourceContentHash(-875_488_538)
internal val Res.string.new_user_tip_1: StringResource by lazy {
      StringResource("string:new_user_tip_1", "new_user_tip_1", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1534, 50),
      ))
    }

@delegate:ResourceContentHash(-1_935_967_050)
internal val Res.string.new_user_tip_2: StringResource by lazy {
      StringResource("string:new_user_tip_2", "new_user_tip_2", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1585, 90),
      ))
    }

@delegate:ResourceContentHash(-803_722_952)
internal val Res.string.next: StringResource by lazy {
      StringResource("string:next", "next", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1676, 24),
      ))
    }

@delegate:ResourceContentHash(2_552_198)
internal val Res.string.ok: StringResource by lazy {
      StringResource("string:ok", "ok", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1701, 14),
      ))
    }

@delegate:ResourceContentHash(380_059_997)
internal val Res.string.pass_icon: StringResource by lazy {
      StringResource("string:pass_icon", "pass_icon", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1716, 37),
      ))
    }

@delegate:ResourceContentHash(1_813_653_306)
internal val Res.string.password: StringResource by lazy {
      StringResource("string:password", "password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1754, 24),
      ))
    }

@delegate:ResourceContentHash(-2_034_617_444)
internal val Res.string.phone: StringResource by lazy {
      StringResource("string:phone", "phone", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1779, 41),
      ))
    }

@delegate:ResourceContentHash(809_406_567)
internal val Res.string.photo: StringResource by lazy {
      StringResource("string:photo", "photo", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1821, 21),
      ))
    }

@delegate:ResourceContentHash(1_642_092_942)
internal val Res.string.policy_notice: StringResource by lazy {
      StringResource("string:policy_notice", "policy_notice", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1843, 93),
      ))
    }

@delegate:ResourceContentHash(813_010_926)
internal val Res.string.privacy_policy: StringResource by lazy {
      StringResource("string:privacy_policy", "privacy_policy", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9656, 58),
      ))
    }

@delegate:ResourceContentHash(-148_349_271)
internal val Res.string.privacy_policy_content: StringResource by lazy {
      StringResource("string:privacy_policy_content", "privacy_policy_content", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1937, 7718),
      ))
    }

@delegate:ResourceContentHash(1_353_865_830)
internal val Res.string.save: StringResource by lazy {
      StringResource("string:save", "save", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9715, 20),
      ))
    }

@delegate:ResourceContentHash(901_505_559)
internal val Res.string.select_image: StringResource by lazy {
      StringResource("string:select_image", "select_image", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9736, 44),
      ))
    }

@delegate:ResourceContentHash(376_258_645)
internal val Res.string.show_password: StringResource by lazy {
      StringResource("string:show_password", "show_password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9781, 37),
      ))
    }

@delegate:ResourceContentHash(343_052_034)
internal val Res.string.take_photo: StringResource by lazy {
      StringResource("string:take_photo", "take_photo", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9819, 34),
      ))
    }

@delegate:ResourceContentHash(-2_075_472_046)
internal val Res.string.user: StringResource by lazy {
      StringResource("string:user", "user", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9896, 24),
      ))
    }

@delegate:ResourceContentHash(1_452_306_180)
internal val Res.string.user_icon: StringResource by lazy {
      StringResource("string:user_icon", "user_icon", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9854, 41),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("Authorized_data", Res.string.Authorized_data)
  map.put("add", Res.string.add)
  map.put("add_facial", Res.string.add_facial)
  map.put("admin_panel_mobile", Res.string.admin_panel_mobile)
  map.put("app_name", Res.string.app_name)
  map.put("back", Res.string.back)
  map.put("bound", Res.string.bound)
  map.put("cancel", Res.string.cancel)
  map.put("connecting_to_server", Res.string.connecting_to_server)
  map.put("cpf", Res.string.cpf)
  map.put("database_error", Res.string.database_error)
  map.put("delete", Res.string.delete)
  map.put("edit", Res.string.edit)
  map.put("error", Res.string.error)
  map.put("example", Res.string.example)
  map.put("exit", Res.string.exit)
  map.put("facial", Res.string.facial)
  map.put("full_name", Res.string.full_name)
  map.put("hint_screen_header", Res.string.hint_screen_header)
  map.put("hint_screen_line_1", Res.string.hint_screen_line_1)
  map.put("hint_screen_line_2", Res.string.hint_screen_line_2)
  map.put("hint_screen_line_3", Res.string.hint_screen_line_3)
  map.put("hint_screen_line_4", Res.string.hint_screen_line_4)
  map.put("hint_screen_line_5", Res.string.hint_screen_line_5)
  map.put("login", Res.string.login)
  map.put("loyola", Res.string.loyola)
  map.put("new_user_tip_1", Res.string.new_user_tip_1)
  map.put("new_user_tip_2", Res.string.new_user_tip_2)
  map.put("next", Res.string.next)
  map.put("ok", Res.string.ok)
  map.put("pass_icon", Res.string.pass_icon)
  map.put("password", Res.string.password)
  map.put("phone", Res.string.phone)
  map.put("photo", Res.string.photo)
  map.put("policy_notice", Res.string.policy_notice)
  map.put("privacy_policy", Res.string.privacy_policy)
  map.put("privacy_policy_content", Res.string.privacy_policy_content)
  map.put("save", Res.string.save)
  map.put("select_image", Res.string.select_image)
  map.put("show_password", Res.string.show_password)
  map.put("take_photo", Res.string.take_photo)
  map.put("user", Res.string.user)
  map.put("user_icon", Res.string.user_icon)
}
